import vcolorpicker from 'vcolorpicker';
import Vue from "vue";
Vue.use(vcolorpicker)

export default vcolorpicker
